var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAxios = function SvgAxios(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600.1 152.1"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "277.6 147.3 313.4 147.3 313.4 4.6 277.6 4.6 277.6 147.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M402.2,117.3c22.7,0,39.4-19.5,39.4-41.4s-16.8-41.2-39.4-41.2-39.5,19.3-39.5,41.2,16.8,41.4,39.5,41.4M402.5,0c42.9,0,77.4,32.9,77.4,75.6s-34.8,76.5-77.8,76.5-77.8-33.1-77.8-75.9S359.6,0,402.5,0M484,104.2l32.8-7.7c2.4,17.2,15,23.4,28.2,23.4s18-7.7,18-13.7c0-4.8-2.8-9.6-12.4-11.5l-20-3.9c-23.9-4.6-40.9-19.5-40.9-42.4,0-27.3,25.1-46.5,53.5-46.5,36.6,0,51.6,22.6,54.2,41.6l-32.2,9c-1.7-11.7-9-20.1-22.2-20.1-11.4,0-16.9,7.5-16.9,13.3,0,4.8,2.3,10.2,10.8,11.9l20.9,4c27.3,5.2,42.3,21.7,42.3,43.2,0,23.4-20.3,45.8-55.1,45.8-36.6-.3-56.2-19.2-61-46.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "38.5 147.3 0 147.3 63.7 4.6 102.4 4.6 38.5 147.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "220.9 74.3 268.7 4.5 225 4.5 199.2 46.8 174 4.5 129.6 4.5 178.1 74.3 151.1 113.5 102.5 4.6 63.8 4.6 127.7 147.3 169 147.3 199.2 102.1 229 147.3 270.8 147.3 220.9 74.3"
  }))));
};
export default SvgAxios;